
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice-tests/act",
      function () {
        return require("private-next-pages/practice-tests/act.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice-tests/act"])
      });
    }
  